<template>
  <div class="select-dpt-user">
    <div @click="triggerClick">
      <el-button v-if="!$slots.default" type="primary">选择部门、选择人员</el-button>
      <slot></slot>
    </div>
    <Dialog :title="dialogTitle" :closeOnModal="false" @close="close" :appendToBody="appendToBody"
      :modalAppendToBody="appendToBody" :padding="0" v-model="dialogVisible">
      <div class="flex-stretch" v-loading="loading">
        <section class="select-section section-left">
          <div class="flex-center mb20">
            <div class="title-border"></div>
            <div class="title-text">选择</div>
          </div>
          <div class="mb20">
            <el-input v-model="searchValue" style="width: 100%;" @input="querySearch" @clear="clearSearch"
              placeholder="搜索" prefix-icon="el-icon-search" :trigger-on-focus="false" clearable></el-input>
          </div>
          <div v-show="!searchValue" class="mb20 flex-center crumb-box" :class="{ 'crumb-over': crumbOver }">
            <div class="crumb-back" v-if="crumbOver" @click="crumbClick(crumb[0], 0)">团队 >... </div>
            <div class="flex-center crumb">
              <div v-for="(item, index) in crumb" class="crumb-item" :class="{ 'crumb-last': index === crumb.length - 1 }"
                :key="index" @click="crumbClick(item, index)">
                <i v-if="item.loading" class="el-icon-loading mr5"></i>
                <span>{{ item.label }}</span>
                <span v-if="index !== crumb.length - 1" class="mr5"> > </span>
              </div>
            </div>
          </div>
          <div v-loading="crumbLoading" class="list-box">
            <div class="mb30" v-show="!searchValue && limit > 1">
              <el-checkbox v-model="checkAll" @change="checkAllChange">全选</el-checkbox>
            </div>
            <div v-show="treeData.length > 0">
              <el-tree :props="props" :data="treeData" class="trees" ref="tree" node-key="treekey" show-checkbox
                @node-click="nodeClick" @check-change="checkChange">
                <div class="custom-tree-node" slot-scope="{ node, data }">
                  <div class="flex-center-side">
                    <div class="flex-center flex1">
                      <img v-if="data.userId && data.headImg" class="car-icon" :src="data.headImg" alt="">
                      <div v-else-if="data.userId && !data.headImg" class="user-name flex-center-center">{{ node.label |
                        nameSplit }}</div>
                      <img v-if="data.dptId" class="dpt-icon" :src="dptImg" alt="">
                      <div class="flex-center flex1">
                        <div class="over-omit" style="max-width: 180px;">{{ node.label }}</div>
                        <div v-if="data.userNum && type !== 2">({{ data.userNum }})</div>
                      </div>
                    </div>
                    <div>
                      <el-button v-if="data.dptId && !searchValue" :disabled="data.checked" :loading="data.loading"
                        type="text" size="mini">下级</el-button>
                    </div>
                  </div>
                </div>
              </el-tree>
            </div>
            <div v-show="treeData.length === 0 && !crumbLoading">
              <div v-if="searchValue" class="flex-center-center">找不到与“{{ searchValue }}”相关的{{ type === 2 ? '部门' : '成员' }}
              </div>
              <div v-else class="emtyimg-box">
                <el-image :src="emtyImg"></el-image>
                <div>{{ type === 2 ? '暂无部门' : '暂无员工' }}</div>
              </div>
            </div>
          </div>
        </section>
        <section class="select-section section-right">
          <div class="flex-center mb20">
            <div class="title-border"></div>
            <div class="title-text">已选</div>
          </div>
          <div class="result">
            <div class="flex-center-side result-item" v-for="(item, index) in result" :key="index">
              <div class="flex-center">
                <img v-if="item.userId && item.headImg" class="car-icon" :src="item.headImg" alt="">
                <div v-else-if="item.userId && !item.headImg" class="user-name flex-center-center">{{ item.label |
                  nameSplit }}</div>
                <img v-if="item.dptId" class="dpt-icon" :src="dptImg" alt="">
                <span class="over-omit" style="max-width: 200px;">{{ item.label }}</span>
                <span v-if="item.userNum && type !== 2">({{ item.userNum }})</span>
              </div>
              <div class="del-icon" @click="resDel(item, index)">
                <img :src="delIcon" alt="">
              </div>
            </div>
          </div>
        </section>
      </div>
      <template slot="footer">
        <el-button type="primary" plain @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import {
  Tree,
  Button,
  Image,
  Input,
} from 'element-ui';
import Dialog from '@/components/Dialog';
import elementResizeDetectorMaker from 'element-resize-detector';
import lodash from 'lodash';
import emtyImg from '@imgs/empty.png';
import dptImg from '@imgs/work_icon_bumen@2x.png';
import carImg from '@imgs/cur_carhead_default@3x.png';
import delIcon from '@imgs/icon_close2@2x.png';
import useUserStore from '@/store/user';
import { userRangList, dptRangList } from '@/api/select';

export default {
  name: 'selectDptUser',
  components: {
    Dialog,
    'el-tree': Tree,
    'el-button': Button,
    'el-image': Image,
    'el-input': Input
  },
  model: {
    prop: 'defaultChecked',
    event: 'confirm'
  },
  props: {
    appendToBody: {
      type: Boolean,
      default: true
    },
    // 选择类型：1选择人员，2选择部门，3选择部门和人员
    type: {
      type: Number,
      default: 3
    },
    // 树结构
    tree: {
      type: [Array, String],
      default: ''
    },
    // 默认勾选项
    defaultChecked: {
      type: Array,
      default: () => { return [] }
    },
    // 可选数量限制
    limit: {
      type: Number,
      default: 100
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 部门权限类型 rangType 0:全部;1:本级与下级;2:特定单位
    rangType: {
      type: Number,
      default: 0
    },
    // 点击触发栏之前的操作，返回false，可阻止打开弹层
    beforeTrigger: Function,
  },
  data() {
    return {
      treeLoading: false,
      crumbLoading: false,
      loading: false,
      dialogVisible: false,
      checkAll: false,
      searchValue: '',
      dptTree: [],
      emtyImg,
      delIcon,
      props: {
        label: 'label',
        isLeaf: false
      },
      dptImg,
      carImg,
      result: [], // 已选
      crumb: [], // 面包屑
      searchTimer: null,
      crumbOver: false,
      treeData: [], // 树
      actDptId: '',
    };
  },
  computed: {
    userStore() {
      return useUserStore();
    },
    dialogTitle() {
      let res = this.title;
      if (!this.title) {
        switch (this.type) {
          case 1:
            res = '选择成员'
            break;
          case 2:
            res = '选择部门'
            break;
          case 3:
            res = '选择成员'
            break;
          default:
            break;
        }
      }
      return res;
    },
  },
  filters: {
    nameSplit(name) {
      if (!name) return '';
      return name.substring(0, 2);
    },
  },
  watch: {
    result: {
      handler() {
        this.setTreeChecked();
        if (this.type !== 1) {
          this.checkAll = this.treeData.length > 0 && this.treeData.every(ele => this.result.some(r => r.treekey === ele.treekey));
        } else {
          const userArr = this.treeData.filter(ele => ele.userId);
          this.checkAll = userArr.length > 0 && userArr.every(ele => this.result.some(r => r.treekey === ele.treekey));
        }
      },
      deep: true
    },
    treeData: {
      handler() {
        this.setTreeChecked();
        if (this.type !== 1) {
          this.checkAll = this.treeData.length > 0 && this.treeData.every(ele => this.result.some(r => r.treekey === ele.treekey));
        } else {
          const userArr = this.treeData.filter(ele => ele.userId);
          this.checkAll = userArr.length > 0 && userArr.every(ele => this.result.some(r => r.treekey === ele.treekey));
        }
      },
      deep: true
    },
  },
  mounted() { },
  methods: {
    /**
     * 取消
     */
    cancel() {
      this.dialogVisible = false;
      this.close();
    },
    /**
     * 关闭
     */
    close() {
      this.$emit('close');
    },
    /**
     * 设置已选对应的勾选项
     */
    setTreeChecked() {
      if (!this.dialogVisible) return;
      this.$nextTick(() => {
        const keys = this.result.map(ele => ele.treekey);
        this.$refs.tree.setCheckedKeys(keys);
      });
    },
    /**
     * 点击触发栏
     */
    triggerClick() {
      if (this.beforeTrigger && this.beforeTrigger() === false) return;
      this.reset();
      this.setDefault();
      this.dialogVisible = true;
      this.listenCrumb();
      this.loading = true;
      this.getTree().then().finally(() => {
        this.loading = false;
      });
    },
    /**
     * 获取列表
     */
    getTree() {
      return new Promise(async resolve => {
        this.treeLoading = true;
        let list = [];
        if (this.tree) {
          list = [...this.tree];
        } else if (this.type === 2) {
          await this.getDpt().then(res => {
            list = res.dptList;
          });
        } else {
          await Promise.all([this.getDpt(), this.getUser()]).then(res => {
            list = [...res[0].dptList, ...res[1].list];
          });
        }
        this.treeData = list.map(ele => {
          const checked = this.result.some(r => r.treekey === ele.dptId || ele.userId);
          return {
            ...ele,
            checked,
            disabled: this.type === 1 && ele.dptId,
            label: ele.dptName || ele.userNickName,
            treekey: ele.dptId || ele.userId
          };
        });
        this.treeLoading = false;
        resolve();
      });
    },
    /**
     * 获取人员
     */
    getUser() {
      const params = {
        dptId: this.actDptId,
        teamId: this.userStore.teamId,
        userStatus: 1,
        rangType: this.rangType,
        userTeamName: this.searchValue
      };
      return userRangList(params);
    },
    /**
     * 获取部门
     */
    getDpt() {
      const params = {
        dptId: this.actDptId,
        teamId: this.userStore.teamId,
        userStatus: 1,
        rangType: this.rangType,
        dptName: this.searchValue
      };
      return dptRangList(params);
    },
    /**
     * 监听面包屑宽度变化
     */
    listenCrumb() {
      this.$nextTick(() => {
        const erd = elementResizeDetectorMaker();
        const dom = document.querySelector('.crumb');
        erd.listenTo(dom, ele => {
          const w = ele.offsetWidth;
          this.crumbOver = w >= 315;
        });
      });
    },
    /**
     * 清除搜索
     */
    clearSearch() {
      this.crumbLoading = true;
      this.treeData = [];
      this.crumb = [
        {
          label: '团队',
          dptId: ''
        },
      ];
      this.actDptId = undefined;
      this.getTree().then().finally(() => {
        this.crumbLoading = false;
      });
    },
    /**
     * 搜索
     */
    querySearch() {
      if (!this.searchValue) {
        this.clearSearch();
        return;
      }
      this.crumbLoading = true;
      this.treeData = [];
      // 防抖
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.searchTimer = setTimeout(() => {
        this.actDptId = undefined;
        if (this.type === 1) {
          if (this.tree) {
            this.treeData = this.tree.filter(ele => ele.userNickName && ele.userNickName.includes(this.searchValue) && ele.userId).map(ele => {
              return {
                ...ele,
                label: ele.dptName || ele.userNickName,
                treekey: ele.dptId || ele.userId
              };
            });
            this.crumbLoading = false;
            return;
          }
          this.getUser().then(res => {
            this.treeData = res.list.map(ele => {
              return {
                ...ele,
                label: ele.userNickName,
                treekey: ele.userId
              };
            });
          }).finally(() => {
            this.crumbLoading = false;
          });
        } else if (this.type === 2) {
          if (this.tree) {
            this.treeData = this.tree.filter(ele => ele.dptName && ele.dptName.includes(this.searchValue) && ele.dptId).map(ele => {
              return {
                ...ele,
                label: ele.dptName || ele.userNickName,
                treekey: ele.dptId || ele.userId
              };
            });
            this.crumbLoading = false;
            return;
          }
          this.getDpt().then(res => {
            this.treeData = res.dptList.map(ele => {
              return {
                ...ele,
                disabled: this.type === 1 && ele.dptId,
                label: ele.dptName,
                treekey: ele.dptId
              }
            });
          }).finally(() => {
            this.crumbLoading = false;
          });
        } else if (this.type === 3) {
          if (this.tree) {
            this.treeData = this.tree.filter(ele => (ele.userNickName && ele.userNickName.includes(this.searchValue) && ele.userId) || (ele.dptName && ele.dptName.includes(this.searchValue) && ele.dptId)).map(ele => {
              return {
                ...ele,
                label: ele.dptName || ele.userNickName,
                treekey: ele.dptId || ele.userId
              };
            });
            this.crumbLoading = false;
            return;
          }
          Promise.all([this.getDpt(), this.getUser()]).then(res => {
            this.treeData = [...res[0].dptList, ...res[1].list].map(ele => {
              return {
                ...ele,
                disabled: this.type === 1 && ele.dptId,
                label: ele.dptName || ele.userNickName,
                treekey: ele.dptId || ele.userId
              };
            });
          }).finally(() => {
            this.crumbLoading = false;
          });
        }
      }, 1000);
    },
    /**
     * 选择搜索结果
     */
    searchSelect(val) {
      const checked = this.result.findIndex(ele => ele.treekey === val.treekey) > -1;
      if (checked) return;
      this.searchValue = val.lisence;
      this.result.push(val);
      this.$refs.tree.setChecked(val.treekey, true);
    },
    /**
     * 重置
     */
    reset() {
      this.crumb = [
        {
          label: '团队',
          dptId: ''
        },
      ];
      this.result = [];
      this.actDptId = null;
      this.checkAll = false;
      this.searchValue = '';
    },
    /**
     * 设置默认勾选项
     */
    setDefault() {
      const clone = lodash.cloneDeep(this.defaultChecked);
      this.result = clone.map(ele => {
        return {
          ...ele,
          label: ele.userNickName || ele.dptName,
          treekey: ele.userId || ele.dptId
        };
      });
    },
    /**
     * 确定
     */
    confirm() {
      const clone = lodash.cloneDeep(this.result);
      this.dialogVisible = false;
      this.$emit('confirm', clone);
    },
    /**
     * 全选
     */
    checkAllChange(checked) {
      this.treeData.forEach(item => {
        if (this.type !== 1 || (this.type === 1 && !item.dptId)) {
          item.checked = checked;
        }
        const index = this.result.findIndex(ele => ele.treekey === item.treekey);
        if (index === -1 && checked) {
          if (this.type === 1 && item.dptId) return;
          this.result.push(item);
        } else if (index > -1 && !checked) {
          this.result.splice(index, 1);
        }
      });
    },
    /**
     * 点击面包屑
     */
    crumbClick(data, index) {
      const len = this.crumb.length;
      if (len - 1 === index) return;
      this.crumb.splice(index + 1);
      this.crumbLoading = true;
      this.$set(data, 'loading', true);
      this.actDptId = data.dptId;
      this.getTree().then(() => {
        this.crumbLoading = false;
        this.$set(data, 'loading', false);
      });
    },
    /**
     * 下级
     */
    async nodeClick(data) {
      if (data.checked || this.tree) return;
      if (!data.dptId || data.loading || this.treeLoading || this.searchValue) return;
      this.$set(data, 'loading', true);
      this.actDptId = data.dptId;
      await this.getTree().then(() => {
        this.$set(data, 'loading', false);
      });
      this.crumb.push({ ...data });
    },
    /**
     * 删除已选
     */
    resDel(val, index) {
      this.result.splice(index, 1);
      this.$refs.tree.setChecked(val.treekey, false);
    },
    /**
     * 勾选
     */
    checkChange(data, checked) {
      data.checked = checked;
      const index = this.result.findIndex(ele => ele.treekey === data.treekey);
      if (checked && index === -1) {
        if (this.limit === 1) {
          // 单选
          this.result = [{ ...data }];
          this.$refs.tree.setCheckedKeys([data.treekey], true);
        } else {
          this.result.push(data);
        }
      } else if (!checked && index > -1) {
        this.result.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.select-dpt-user {
  line-height: initial;
  display: inline-block;
}

// 超出一行显示省略号
.over-omit {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.crumb-box {
  overflow: hidden;
  position: relative;
}

.crumb-back {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  height: 100%;
  width: 80px;
  color: #333;
  cursor: pointer;
  background: linear-gradient(to left, transparent, #fff 30%);
}

.crumb-over {
  justify-content: flex-end;
}

.crumb {
  white-space: nowrap;
  width: fit-content;
}

.crumb-item {
  color: #333;
  cursor: pointer;
}

.crumb-last {
  color: #888;
  cursor: auto;
}

.result {
  .result-item {
    +.result-item {
      margin-top: 20px;
    }
  }
}

.del-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;

  &:hover {
    opacity: .8;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.car-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}

.dpt-icon {
  width: 20px;
  height: 18px;
  object-fit: cover;
  margin-right: 10px;
}

::v-deep .el-checkbox {
  .el-checkbox__input {
    margin-right: 10px;

    .el-checkbox__inner {
      width: 20px;
      height: 20px;
    }
  }

  .is-checked {
    .el-checkbox__inner {

      // background-color: unset;
      &::after {
        // border: 2px solid #3642FF;
        left: 7px;
        top: 4px;
      }
    }
  }
}

.trees {
  ::v-deep .el-checkbox {
    & .is-disabled {
      visibility: hidden;
      // display: none;
    }
  }
}

::v-deep .el-tree {
  .el-tree-node {
    +.el-tree-node {
      margin-top: 20px;
    }
  }
}

::v-deep .el-tree-node__expand-icon {
  display: none;
}

.custom-tree-node {
  display: block;
  width: 100%;

  ::v-deep .el-button {
    min-width: unset;
  }
}

.title-border {
  width: 3px;
  height: 12px;
  background-color: #333;
  margin-right: 5px;
}

.title-text {
  color: #333;
  font-size: 14px;
  font-weight: bold;
}

.select-section {
  width: 50%;
  height: calc(90vh - 170px);
  overflow-y: auto;
  box-sizing: border-box;
  padding: 30px;
}

.mr5 {
  margin-right: 5px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb30 {
  margin-bottom: 30px;
}

// flex布局
.flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-column {
  @extend .flex;
  flex-direction: column;
}

.flex-column-center {
  @extend .flex-column;
  align-items: center;
}

.flex-center {
  @extend .flex;
  align-items: center;
}

.flex-stretch {
  @extend .flex;
  align-items: stretch;
}

.flex-line {
  @extend .flex;
  align-items: baseline;
}

.flex-center-center {
  @extend .flex-center;
  justify-content: center;
}

.flex-center-side {
  @extend .flex-center;
  justify-content: space-between;
}

.flex-stretch-center {
  @extend .flex-stretch;
  justify-content: center;
}

.flex-stretch-side {
  @extend .flex-stretch;
  justify-content: space-between;
}

.user-name {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #3642FF;
  color: #fff;
  font-size: 12px;
  margin-right: 10px;
}

::v-deep .el-icon-search {
  display: flex;
  align-items: center;
  justify-content: center;
}

.emtyimg-box {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-top: 130px;

  ::v-deep .el-image {
    width: 160px;
  }
}

.list-box {
  min-height: 400px;
}

// element input框尾部图标bug，无论是否设置，都会默认一个图标进去
::v-deep .el-input__validateIcon {
  display: none;
}</style>
